import { render } from "./FarmaciasView.vue?vue&type=template&id=4256b3f0"
import script from "./FarmaciasView.vue?vue&type=script&lang=js"
export * from "./FarmaciasView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__